// @flow
import * as React from 'react';
import styled from 'styled-components';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import translate from 'react-i18next/dist/commonjs/translate';

import Advertiser from 'common/modules/advertiser/domain/Advertiser';
import { getCurrentAdvertiser } from './selectors/advertiserSelectors';
import AdvertiserCard from './components/AdvertiserCard';

const Wrapper = styled.div`
  height: 64px;
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: ${({ theme }) => `${theme.metrics.smallMargin}px ${theme.metrics.smallMargin}px`};
  border-bottom: ${({ theme }) => `solid thin ${theme.colors.lightGray}`};
  background-color: ${({ theme }) => theme.colors.secondaryBackground};
`;

type Props = {
  current?: Advertiser,
}

class CurrentAdvertiserHeader extends React.Component<Props> {
  render() {
    const { current } = this.props;
    if (!current) {
      return null;
    }

    return (
      <Wrapper>
        <AdvertiserCard advertiser={current} />
      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    current: getCurrentAdvertiser(state),
  };
}

function mapDispatchToProps(dispatch: *) {
  return {
    actions: bindActionCreators({}, dispatch),
  };
}

export default translate()(connect(mapStateToProps, mapDispatchToProps)(CurrentAdvertiserHeader));



// WEBPACK FOOTER //
// ./src/advertisers/modules/advertiser/CurrentAdvertiserHeader.js